<template>
  <main :class="{'boxPadding': isBox}">
    <section class="search container">
      <div class="row">
        <div class="col-10 offset-1">
          <form class="form">
            <div class="input-group input-lg">
              <div class="input">
                <input
                type="text"
                name="keyowrd"
                id="keyowrd"
                class="form-control"
                v-model="keyowrd"
                @keydown.enter="filterForType()"
                placeholder="輸入客戶名稱查詢"
                alt="ch">
              </div>
              <button
              class="btn btn-primary btn-icon"
              type="submit"
              @click.prevent="filterForType()">
                <i class="icon-search i-24"></i>
              </button>
            </div>
          </form>
        </div>
      </div>
    </section>

    <section class="container-fluid">
      <h4 class="text-green">
        {{this.$route.query.grp_name}}：{{this.totalCustCount}}位
      </h4>
      <section class="container-fluid mt-1 px-0">
        <div class="form-group row search-checkbox " style="margin-bottom:0px;margin: 0px 0;">
          <label class="d-inline-block pt-2">客戶類型(可複選)：</label>
          <div class="checkbox checkbox-inline">
            <input
            type="checkbox"
            name="customer"
            id="customer-1"
            value="1"
            v-model="csSource">
            <label for="customer-1">壽險客戶</label>
          </div>
          <!-- <div class="checkbox checkbox-inline">
            <input
            type="checkbox"
            name="customer"
            id="customer-2"
            value="2"
            v-model="csSource">
            <label for="customer-2">產險客戶</label>
          </div> -->
          <div class="checkbox checkbox-inline">
            <input
            type="checkbox"
            name="customer"
            id="customer-3"
            value="3"
            v-model="csSource">
            <label for="customer-3">旅平險客戶</label>
          </div>
          <div class="checkbox checkbox-inline">
            <input
            type="checkbox"
            name="customer"
            id="customer-4"
            value="4"
            v-model="csSource">
            <label for="customer-4">房貸客戶</label>
          </div>
          <div class="checkbox checkbox-inline">
            <input
            type="checkbox"
            name="customer"
            id="customer-5"
            value="5"
            v-model="csSource">
            <label for="customer-5">團險客戶</label>
          </div>
          <div class="checkbox checkbox-inline">
            <input
            type="checkbox"
            name="customer"
            id="customer-6"
            value="6"
            v-model="csSource">
            <label for="customer-6">準保戶</label>
          </div>
        </div>
      </section>
      <div :class="{
        'section-loading': isLoading_1
      }">
        <table id="datatable" class="group-table table datatable table-striped table-bordered">
          <thead>
            <tr>
              <th width="120px">
                <div class="checkbox checkbox-inline mr-0">
                  <input @click="checkAllClick = true" type="checkbox" name="check-all" id="check-all" value="1" v-model="checkAll">
                  <label for="check-all"></label>
                </div>
                #
              </th>
              <th width="110px"
              :class="'sorting ' + (order.fieldName == 'NAME' ? (order.asc ? 'sorting_asc' : 'sorting_desc') : '')"
              @click="processCustList('NAME')"           
              >姓名</th>
              <th width="110px"
              :class="'sorting ' + (order.fieldName == 'ID' ? (order.asc ? 'sorting_asc' : 'sorting_desc') : '')"
              @click="processCustList('ID')"                 
              >身分證</th>
              <th width="110px"
              :class="'sorting ' + (order.fieldName == 'MOBILE' ? (order.asc ? 'sorting_asc' : 'sorting_desc') : '')"
              @click="processCustList('MOBILE')"                 
              >手機</th>
              <th width="125px"
              :class="'sorting ' + (order.fieldName == 'PHONE' ? (order.asc ? 'sorting_asc' : 'sorting_desc') : '')"
              @click="processCustList('PHONE')"                 
              >電話</th>
              <th width="100px"
              :class="'sorting ' + (order.fieldName == 'BIRTHDAY' ? (order.asc ? 'sorting_asc' : 'sorting_desc') : '')"
              @click="processCustList('BIRTHDAY')"                
              >生日</th>
              <th width="*"
              :class="'sorting ' + (order.fieldName == 'address' ? (order.asc ? 'sorting_asc' : 'sorting_desc') : '')"
              @click="processCustList('address')"                
              >住家地址</th>
              <th width="167px"
              :class="'sorting ' + (order.fieldName == 'mkt_type' ? (order.asc ? 'sorting_asc' : 'sorting_desc') : '')"
              @click="processCustList('mkt_type')"                
              >泰好客<span class="questionmark-icon" @click="openCathayCustInfoModal()">?</span></th>
            </tr>
          </thead>
          <tbody @scroll="scrollmethod" v-if="tableData.length" :style="`height: ${data_table_height}px`">
            <tr v-for="(d, did) in tableData" :key="`td-${did}`">
              <td width="120px">
                <div class="checkbox checkbox-inline mr-0">
                  <input @click="checkAllClick = false" type="checkbox" name="td-item" :id="`check-${did}`" :value="d.ID" v-model="selection">
                  <label :for="`check-${did}`"></label>
                </div>
                <span class="no">{{did + 1}}</span>
                <span class="info text-center">
                  <level :lv="Number(d.VIP_LVL)" />
                  <avatar :gender="Number(d.SEX)" :size="20" />
                </span>
              </td>
              <td width="110px">
                <Tooltip
                  :position="did < 3 ? 'bottom' : 'top'"
                  :name="d.NAME"
                  :id="d.showid"
                  :mobile="d.MOBILE"
                  :phone="d.PHONE"
                  :birthday="d.BIRTHDAY"
                  :address="d.address"
                >
                  <a
                    @click.prevent="toCustDetail(d.ID, d.NAME)"
                    class="link text-underline"
                  >{{d.NAME | getMaskName}}</a><span>{{isLostLife(d.IS_LIA)}}</span>
                </Tooltip>
              </td>
              <td width="110px">{{d.showid | getMaskID}}</td>
              <td width="110px">{{d.MOBILE | getMaskMobile}}</td>
              <td width="125px">{{d.PHONE | getMaskPhone}}</td>
              <td width="100px">
                <div class="date">{{d.BIRTHDAY | dateFormat | getMaskBirthday}}</div>
                <div class="age">
                  <!--<b v-if="d.AGE &&(d.AGE != '0' ||d.AGE != '')">{{d.AGE}}</b>
                  <template v-if="d.AGE &&(d.AGE != '0' ||d.AGE != '')">歲</template>-->
                  <b v-if="d.AGE == 0">0歲</b>
                  <b v-else-if="d.AGE">{{d.AGE}}歲</b>
                  <b v-else>— —</b>
                </div>
              </td>
              <td width="*">{{d.address | getMaskAddress}}</td>
              <td width="150px">
                <span v-if="d.SOURCE1 != '1'">
                  目前無泰好客資訊
                </span>
                <span v-else>
                  <span class="mkt-type-use"
                    :class="d.HOS_MKT_LEVEL ? d.HOS_MKT_LEVEL == '1' ? 'bg-green1' : 'bg-green2' : 'bg-gray'"
                  >住</span>
                  <span class="mkt-type-use"
                    :class="d.SUR_MKT_LEVEL ? d.SUR_MKT_LEVEL == '1' ? 'bg-green1' : 'bg-green2' : 'bg-gray'"
                  >手</span>
                  <span class="mkt-type-use"
                    :class="d.REI_MKT_LEVEL ? d.REI_MKT_LEVEL == '1' ? 'bg-green1' : 'bg-green2' : 'bg-gray'"
                  >實</span>
                  <span class="mkt-type-use"
                    :class="d.ACC_MKT_LEVEL ? d.ACC_MKT_LEVEL == '1' ? 'bg-green1' : 'bg-green2' : 'bg-gray'"
                  >意</span>
                  <span class="mkt-type-use"
                    :class="d.DD_MKT_LEVEL ? d.DD_MKT_LEVEL == '1' ? 'bg-green1' : 'bg-green2' : 'bg-gray'"
                  >重</span><br>
                  <span class="mkt-type-use"
                    :class="d.LTC_MKT_LEVEL ? d.LTC_MKT_LEVEL == '1' ? 'bg-green1' : 'bg-green2' : 'bg-gray'"
                  >長</span>
                  <span class="mkt-type-use"
                    :class="d.LIFE_MKT_LEVEL ? d.LIFE_MKT_LEVEL == '1' ? 'bg-green1' : 'bg-green2' : 'bg-gray'"
                  >壽</span>
                  <span class="mkt-type-use"
                    :class="d.SAV_MKT_LEVEL ? d.SAV_MKT_LEVEL == '1' ? 'bg-orange1' : 'bg-orange2' : 'bg-gray'"
                  >儲</span>
                    <span class="mkt-type-use"
                    :class="d.INV_MKT_LEVEL ? d.INV_MKT_LEVEL == '1' ? 'bg-orange1' : 'bg-orange2' : 'bg-gray'"
                  >投</span>
                </span>
              </td>
            </tr>
          </tbody>
          <tbody v-else>
            <tr>
              <td colspan="7" class="empty">
                <h3 class="text-center py-5">{{remoteDataMsg}}</h3>
              </td>
              <td v-show="false"></td>
              <td v-show="false"></td>
              <td v-show="false"></td>
              <td v-show="false"></td>
              <td v-show="false"></td>
              <td v-show="false"></td>
            </tr>
          </tbody>
        </table>
      </div>
      <section class="container-fluid">
        <fixed-botton v-show="!isScroll">
          <template slot="@function">
            <div>
              <button class="btn btn-default"
              v-if="showDeleteBtn"
              @click="deleteResult"
              :disabled="!selection.length">
                刪除客戶
              </button>
              <button class="btn btn-primary mr-0"
              @click="openPrintModal"
              :disabled="!selection.length">
                列印名條
              </button>
            </div>
          </template>
        </fixed-botton>
      </section>
    </section>
    
    <warning-modal
    :open="WarningModalOpen"
    :message="deleteWarningMessage"
    @close="panelClose('WarningModalOpen')"
    @submit="submitDeleteResult"/>

    <warning-modal
    :open="WarningDoubleCheckModalOpen"
    :message="WarningDoubleCheckModalMessage"
    :confirmText="`確認刪除`"
    @close="panelClose('WarningDoubleCheckModalOpen')"
    @submit="deleteCustomer"/>

    <print-modal
    :open="printModalOpen"
    :custs="selectionWithMobile"
    :order="order"
    @close="panelClose('printModalOpen')"/>

    <!-- 泰好客說明視窗 -->
    <cathay-cust-info-modal
      :open="cathayCustInfoModalOpen"
      @close="panelClose('cathayCustInfoModalOpen')"
    />

    <!-- 打開遮罩 -->
    <mxMask :open="mxMaskOpen" content="資料刪除中，請稍候..." />
  </main>
</template>

<script>
import {commonMixin} from '../../mixins/common'
import {mapActions, mapGetters} from 'vuex'
import PrintModal from '../components/PrintModal'
import Avatar from '../../components/Avatar'
import Level from '../../components/Level'
import WarningModal from '../components/WarningModal'
import WarningDoubleCheckModal from '../components/WarningModal'
import CathayCustInfoModal from "@/desktop/components/CathayCustInfoModal"
import FixedBotton from '../components/fixedBotton'
import { getGroupMember, deleteCust, doSortList } from '../../service'
import Tooltip from '@/desktop/components/ToolTip'
import mxMask from "@/desktop/components/mxMask"

const is_iPad = navigator.userAgent.match(/iPad/i) != null // 確認裝置是否為 iPad
let windowWidth = -520;
if(is_iPad){
  windowWidth = -470;
}

export default {
  name: 'GroupMember',
  mixins: [commonMixin],
  watch: {
    checkAll: function(val){
      if(val && this.checkAllClick) {
        this.selection = []
        this.tableData.forEach(data => {
          this.selection.push(data.ID)
        });
      } else if(this.checkAllClick){
        this.selection = []
      }
    },
    selection: function(){
      if(this.tableData.length == 0) {
        this.checkAll = false
      }else if(this.tableData.length !== this.selection.length && !this.checkAllClick){
        this.checkAll = false
      }else if(!this.checkAllClick){
        this.checkAll = true
      }
    },
    tableData () {
      this.registerHanlink()
    },
    csSource: function(newAry) {
      this.$store.dispatch("updaCustType", newAry);
      var val = newAry.find(function(e) {
        return e == 6;
      });
      if (newAry.length == 1 && val == 6) {
        this.showDeleteBtn = true;
      } else {
        this.showDeleteBtn = false;
      }
      this.filterForType();
    },
    keyowrd(newVal) {
      this.keyowrd = this.cleanSpecialChar(newVal);
    }
  },
  computed: {
    ...mapGetters(['BaseUrl', 'UserInfo']),
    // 計算篩選結果客戶數量
    totalCustCount () {
      return this.tableData.length
    },
    isBox() {
      return this.UserInfo.userType === 'box';
    }
  },
  components: {
    PrintModal, Avatar, Level, WarningModal, WarningDoubleCheckModal, CathayCustInfoModal, FixedBotton, Tooltip, mxMask
  },
  data () {
    return {
      remoteDataMsg:"此群組無客戶資料",
      isLoading_1: false,
      printModalOpen: false,
      checkAll: false,
      WarningModalOpen:false,
      WarningDoubleCheckModalOpen:false,
      cathayCustInfoModalOpen: false,
      selection: [],
      selectionWithMobile: [],
      keyowrd: '',
      tableData: [{},{}],
      memDatas: [],
      tableDataBackup: [],
      csSource: ['1','3','4','5','6'],
      checkAllClick: false,
      data_table_height: 0,
      order: {
        fieldName: 'NAME',
        asc: true
      },
      showDeleteBtn: false,
      deleteWarningMessage:"您確定要刪除這些「準保戶」的客戶嗎？",
      WarningDoubleCheckModalMessage:"系統會同步刪除「<span style='color:red;'>客戶情報</span>」、「<span style='color:red;'>保單健檢</span>」及「<span style='color:red;'>建議書</span>」相關資訊，確認刪除後資料將無法回復，請確認是否刪除？",
      isScroll: false, //是否滾動
      bottomWidth: windowWidth,
      scrollPostion: 25, // 顯示當前位置
      scrollPostionOffset: 10, // 1次render筆數
      isToBottom: false, // 是否捲動到最下面
      nowTime:0,
      lastTime:0,
      mxMaskOpen: false
    }
  },
  methods: {
    ...mapActions([
      'setPageLock','updateCustID'
    ]),
    toCustDetail(custId, custName){
      if (this.isBox) {
        this.boxCustInfo(custId, custName);
      } else {
        this.updateCustID(custId);
        localStorage.CustID = custId;
        this.$router.push({path: `/detail/CustID/tab/1`});
      }
    },
    deleteResult(){
      this.panelOpen('WarningModalOpen')
    },
    submitDeleteResult(){
      this.panelClose('WarningModalOpen')
      this.panelOpen('WarningDoubleCheckModalOpen')
    },
    isLostLife(is_lia){
      return is_lia == 'Y' ? ' (歿)' : ''
    },
    initGroupMember() {
      this.selection = []
      this.isLoading_1 = true
      
      getGroupMember(this.$store.state.userInfo.id, this.$route.query.grp_id).then(result => {
        if(result) {
          let pattern = /^[0-9]+$/;
          // 過濾掉 source 為 N 的資料
          let resData = result.filter(item => { return item.SOURCE1 !== 'N'})
          // 組合 source 成一個數字 array
          resData.forEach(item => {
            item.sourceFilter = []
            for (let i = 1; i < 7; i++) {
              if (item[`SOURCE${i}`] !== '0') {
                item.sourceFilter.push(`${i}`)
              }
            }
            if (item.ID && item.ID.includes('~')) {
              //若客戶為無ID，則不顯示流水號ID
              item.showid = '— —';
            } else {
              item.showid = item.ID || '— —';
            }
            item.id = item.ID || '';

            item.MOBILE = item.MOBILE ? item.MOBILE.trim() : '— —'
            item.mobile = item.MOBILE || '';

            //現居地址
            item.address =
              (item.HOME_ADDR_ZIP ? item.HOME_ADDR_ZIP.trim() : "") +
              (item.HOME_ADDR1 ? item.HOME_ADDR1.trim() : "") +
              (item.HOME_ADDR2 ? item.HOME_ADDR2.trim() : "") +
              (item.HOME_ADDR3 ? item.HOME_ADDR3.trim() : "");

            let val = item.address
            if(val && val.trim() && val !== '— —'){
              let firstWords = val.substring(0, 5)
              let len = val.length;
              if (pattern.test(firstWords)) {
                  let words = val.substring(5, len);
                  val = item.address.substring(0, 3);
                  val = val + words;          
              }else{
                  val = item.address; 
              }
            }
            item.address = val;
            //公司地址
            item.company_address =
              (item.CORP_ADDR_ZIP ? item.CORP_ADDR_ZIP.trim() : "") +
              (item.CORP_ADDR1 ? item.CORP_ADDR1.trim() : "") +
              (item.CORP_ADDR2 ? item.CORP_ADDR2.trim() : "") +
              (item.CORP_ADDR3 ? item.CORP_ADDR3.trim() : "");

            //生日排序
            let ageText = this.paddingLeft(item.AGE == "0" ? "0" : item.AGE ? item.AGE : "00000", 4, "0");
            let birthdayText = item.BIRTHDAY || "0000-01-01";
            item.birthdaySort = ageText + "_" + birthdayText;

            //泰好客
            item.mkt_score = this.getMktScore(item);
          })
          this.memDatas = resData
          //this.memDatas = this.memDatas.filter(item =>
          // item.sourceFilter[0]!=='2'
          // )
          this.tableData = [...this.memDatas]
        } else {
          this.memDatas = []
          this.tableData = [...this.memDatas]
        }

        // //若客戶類型篩選設定有異動過，要保留前次設定內容
        // let chkCustType = this.$store.state.custType;
        // if (
        //   chkCustType &&
        //   (!chkCustType.includes("1") ||
        //     // !chkCustType.includes("2") ||
        //     !chkCustType.includes("3") ||
        //     !chkCustType.includes("4") ||
        //     !chkCustType.includes("5") ||
        //     !chkCustType.includes("6"))
        // ) {
        //   this.csSource = chkCustType;
        // }
        this.isLoading_1 = false
      })
      //卷軸位置初始化
      this.resetPosition();
    },
    processCustList (fieldName) {
      console.log(`>>>>> columnSorting:${fieldName} <<<<<`)
      //切換表頭圖案
      if(this.order.fieldName == fieldName) {
          this.order.asc = !this.order.asc
      } else {
        console.log('change sort field')
        this.order.fieldName = fieldName
        this.order.asc = true
        console.log(this.order)
      }

      //data排序
      let sortOrder = -1
      if(this.order.asc) {
        sortOrder = 1
      }

      switch (fieldName) {
        case 'mkt_type':
          let tmpdata = [...this.tableData];
          this.tableData= [];
          setTimeout(() => {
          this.tableData = tmpdata;
          this.tableData.sort(this.sortCompareFun(sortOrder, "mkt_score"));
          this.registerHanlink(); // 難字顯示
          }, 20);
          break;
        case 'BIRTHDAY':
          let savedata = [...this.tableData];
          this.tableData= [];
          setTimeout(() => {
          this.tableData = savedata;
          this.tableData.sort(this.sortCompareFun(sortOrder, "birthdaySort"));
          this.registerHanlink(); // 難字顯示
          }, 20);
          break;
        case 'NAME':
          this.sortByName(sortOrder);
          break;
        default:
          let savetable = [...this.tableData];
          this.tableData = [];
          setTimeout(() => {
          this.tableData = savetable;
          this.tableData.sort(this.sortCompareFun(sortOrder, fieldName));
          this.registerHanlink(); // 難字顯示
          }, 20);
      }
    },
    sortByName(sortOrder) {
      if (this.tableData.length == 0) {
        return;
      }

      let tempData = this.tableData;
      this.tableData = [];
      this.remoteDataMsg = "資料排序中，請稍候...";
      doSortList(
        this.$store.state.userInfo.id,
        sortOrder,
        tempData,
        "NAME"
      ).then((result) => {
        if (result.header && result.header.status === "200") {
          this.tableData = result.body.result;
        } else {
          if (result.header && result.header.message) {
            this.$toast.info({ title: result.header.message });
          } else {
            this.$toast.info({ title: "姓名排序異常,請重新操作" });
          }
          this.tableData = tempData;
        }
        this.registerHanlink(); // 難字顯示
        this.remoteDataMsg = "此群組無客戶資料";
      });
    },
    //計算泰好客加權分數
    getMktScore(data) {
      if (data.SOURCE1 != "1") {
        return -1; //目前無泰好客資訊，則分數為-1
      }
      let mktType = ["HOS_MKT_LEVEL", "SUR_MKT_LEVEL", "REI_MKT_LEVEL",
       "ACC_MKT_LEVEL", "DD_MKT_LEVEL", "LTC_MKT_LEVEL", "LIFE_MKT_LEVEL", "SAV_MKT_LEVEL", "INV_MKT_LEVEL"];
      let returnScore = 0;

      //類型為1(分數2)，類型為2 or 3 (分數1)，其餘分數0
      mktType.forEach(value => {
        if (data[value] == "1") {
          returnScore += 2;
        } else if(data[value] == "2" || data[value] == "3") {
          returnScore += 1;
        }
      });

      return returnScore;
    },
    filterForType(){
      this.checkAllClick = false
      this.selection = []
      this.tableData = []
      this.isToBottom = false
      this.resetPosition()
      setTimeout(() => {
        this.tableData = this.memDatas.filter(item => {
          if(this.csSource.includes('1') ){
            if(item.sourceFilter.includes('1') && item.NAME.includes(this.keyowrd)){
              return item
            }
          }
          // if(this.csSource.includes('2') ) {
          //   if(item.sourceFilter.includes('2') && item.NAME.includes(this.keyowrd)){
          //     return item
          //   }
          // }
          if(this.csSource.includes('3') ) {
            if(item.sourceFilter.includes('3') && item.NAME.includes(this.keyowrd)){
              return item
            }
          }
          if(this.csSource.includes('4') ) {
            if(item.sourceFilter.includes('4') && item.NAME.includes(this.keyowrd)){
              return item
            }
          }
          if(this.csSource.includes('5') ) {
            if(item.sourceFilter.includes('5') && item.NAME.includes(this.keyowrd)){
              return item
            }
          }
          if(this.csSource.includes('6') ) {
            if(item.sourceFilter.length === 1 && item.sourceFilter.includes('6') && item.NAME.includes(this.keyowrd)){
              return item
            }
          }                                                
        })
        this.registerHanlink() // 難字顯示
      }, 20);
    },
    dateCompareFun(sortOrder, property) {
      let vm = this
      return function(a, b) {
        console.log();
        let date_a = new Date(a[property]? a[property] : '1880-01-01').getTime() 
        let date_b = new Date(b[property]? b[property] : '1880-01-01').getTime() 
        let result = (date_a < date_b) ? -1 : 1
        return result * sortOrder
      }
    },
    deleteCustomer () {
      this.panelOpen("mxMaskOpen");//開啟遮罩
      deleteCust(this.$store.state.userInfo.id, "csids", "", "", this.selection).then(result =>{
        this.panelClose("mxMaskOpen");//關閉遮罩
        if (result && result.header.status == '200') {
          this.panelClose('WarningDoubleCheckModalOpen')
          this.$toast.info({title: `刪除成功`})
          this.$router.push({path:`/`})
        }
        else {  
          this.panelClose('WarningDoubleCheckModalOpen')
          this.$toast.info({title: `刪除失敗`})
        }
      })         
    },
    // doSearch () {
    //   if (!this.$store.state.compositionStatus) {
    //     this.checkAllClick = false
    //     this.selection = []
    //     let s1 = this.csSource.s1 == true ? "1":'N'
    //     let s2 = this.csSource.s2 == true ? "2":'N'
    //     let s3 = this.csSource.s3 == true ? "3":'N'
    //     let s4 = this.csSource.s4 == true ? "4":'N'
    //     let s5 = this.csSource.s5 == true ? "5":'N'
    //     let s6 = this.csSource.s6 == true ? "6":'N'    
    //     this.tableData = this.memDatas.filter(item => {
    //         if(s1 != 'N' ){
    //           if(item.source1.includes(s1) && item.name.includes(this.keyowrd)){
    //             return item
    //           }
    //         }
    //         if(s2 != 'N') {
    //           if(item.source2.includes(s2) && item.name.includes(this.keyowrd)){
    //             return item
    //           }
    //         }
    //         if(s3 != 'N') {
    //           if(item.source2.includes(s3) && item.name.includes(this.keyowrd)){
    //             return item
    //           }
    //         }
    //         if(s4 != 'N') {
    //           if(item.source2.includes(s4) && item.name.includes(this.keyowrd)){
    //             return item
    //           }
    //         }
    //         if(s5 != 'N') {
    //           if(item.source2.includes(s5) && item.name.includes(this.keyowrd)){
    //             return item
    //           }
    //         }
    //         if(s6 != 'N') {
    //           if(item.source2.includes(s6) && item.name.includes(this.keyowrd)){
    //             return item
    //           }
    //         }                                                
    //       })
    //       this.registerHanlink()
    //   }
    // },
    openPrintModal () {
      //排序從[點選順序]變更為[目前Table的排序]
      this.selection = this.sortByPattern('ID', this.tableData, this.selection)
      this.selectionWithMobile = [];
      this.selection.forEach(sel => {
        let tmpData = this.tableData.find(data => {
          return data.ID === sel;
        });
        if(tmpData) {
          this.selectionWithMobile.push(tmpData);
        }
      });
      this.panelOpen('printModalOpen')
    },
    //開啟泰好客說明視窗
    openCathayCustInfoModal () {
      this.panelOpen('cathayCustInfoModalOpen');
    },
    sortByPattern(propertyStr, patternObjectArray, targetArray) {
      var targetWithIndexArray = []
      var targetCount = targetArray.length
      var patternCount = patternObjectArray.length
      for(var i=0; i<targetCount; i++) {
        var targetProperty = targetArray[i]
        for(var j=0; j<patternCount; j++) {
          if(targetProperty == patternObjectArray[j][propertyStr]) {
            var obj = {}
            obj['index'] = j
            obj[propertyStr] = targetProperty
            targetWithIndexArray.push(obj)
            break;
          }
        }
      }
      var sortedArray = targetWithIndexArray.sort(this.sortCompareFun(1, 'index'))
      return sortedArray.map((ele) => {return ele[propertyStr]})
    },
    sortCompareFun(sortOrder, property) {
      return function(a, b) {
        let result = (a[property] < b[property]) ? -1 : (a[property] > b[property]) ? 1 : 0;
        return result * sortOrder;
      }
    },
    handleScroll() {
      // ----滾動顯示/隱藏----
      this.isScroll = true;
      clearTimeout(this.scrolltimeOutProcessId);
      this.scrolltimeOutProcessId = setTimeout(() => {
        this.isScroll = false;
      }, 500);
      // ----滾動顯示/隱藏----
    },
    scrollmethod(e){
      this.nowTime = +new Date()
      if (this.nowTime > this.lastTime + 150) {
        this.lastTime = this.nowTime;
        const tempPostion = e.target.scrollTop / 69 + this.scrollPostionOffset;
        this.scrollPostion = Math.max(this.scrollPostion, tempPostion);
        if (!this.isToBottom) {
          if (e.target.scrollHeight - e.target.scrollTop - e.target.clientHeight <= 50) {
            //當滾動卷軸接近底端，縮小表格高度
            if (is_iPad) {
              this.data_table_height = $(window).height() - 350;
            } else {
              this.data_table_height = $(window).height() - 420;
            }
            this.isToBottom = true;
          }
        }
      }
    },
    //畫面初始化(卷軸, 表格高度)
    resetPosition() {
      this.scrollPostion = 25;
      this.scrollPostionOffset = 10;
      this.data_table_height = $(window).height() - 290
    }    
  },
  mounted () {
    window.addEventListener("scroll", this.handleScroll, true);
    this.initGroupMember();
    let self = this;
    $(window).bind('orientationchange', function(event) {
      $(window).one('resize', function() {
        self.data_table_height = $(window).height() - 310
      });
    }); 
  },
}
</script>

<style lang="scss" scoped>

.group-table thead tr,.group-table tbody tr {
  display: table;
  width: 100%;
  table-layout: fixed;
}

.group-table tbody {
  display: block;
  height: 350px;
  overflow-y: scroll;
  border: 0 !important;
  -webkit-overflow-scrolling: touch;
  
  &::-webkit-scrollbar {
    width: 17px; 
    border: 0;
    box-shadow: none;
  }
  
  &::-webkit-scrollbar-track
  {
    box-shadow: none;
    border-radius: 0px;
    border: 0;
    background-color: #F5F5F5;
  }

  &::-webkit-scrollbar-thumb
  {
    width: 10px;
    border-radius: 20px;
    background-color: #555;
  }

  &.sorting,
  &.sorting_desc {
    position: relative;
    padding-right: 25px !important;
    
    &:before,
    &:after {
      content: '';
      position: absolute;
      width: 0px;
      height: 0px;
      display: block;
      top: 0;
      bottom: 0;
      right: 6px;
      margin: auto;
    }

    &:after {
      top: 18px;
      border-top: 6px solid transparentize(#027A39, .5);
      border-left: 5px solid transparent;
      border-right: 5px solid transparent;
      border-bottom: 6px solid transparent;
    }

    &:before {
      top: -13px;
      border-bottom: 6px solid transparentize(#027A39, .5);
      border-left: 5px solid transparent;
      border-right: 5px solid transparent;
      border-top: 6px solid transparent;
    }
  }

  &.sorting_asc:before {
    border-bottom: 6px solid transparentize(white, .5);
  }

  &.sorting_desc:after {
    border-top: 6px solid transparentize(white, .5);
  }

  &.no-sort:before,
  &.no-sort:after {
    display: none;
  }
}

.boxPadding {
  padding-top: 0px !important;
}

.bg-green1 {
  background-color: rgb(0,128,0);
}

.bg-green2 {
  background-color: rgb(146,208,80);
}

.bg-gray {
  background-color: rgb(230,230,230);
}

.bg-orange1 {
  background-color: rgb(245, 136, 26);
}

.bg-orange2 {
  background-color: rgb(244, 177, 131);
}

.mkt-type-use {
  padding: 1px 4px;
  display: inline-block;
  border-radius: 50%;
  width: 22px;
  height: 22px;
  color: #fff;
  font: 14px Arial, sans-serif;
  font-weight: 600;
  margin-bottom: 2px;
  margin-right: 3px;
}

.questionmark-icon {
  border-radius: 50%;
  border:2px solid #fff;
  width: 36px;
  height: 36px;
  padding: 1px 4px 1px 4px;
  color: #fff;
  text-align: center;
  font: 12px Arial, sans-serif;
  font-weight: 600;
  cursor: pointer;
}
</style>